<div class="SLV2-view-pdf-body">
   <div class="SLV2-body-section document-body-section">
    <div class="SLV2-section-wrap SLV2-page-header-area">
            <div class="SLV2-page-header-lft">
                <!-- navigateToSelfLearnHomePage() -->
                <button class="SLV2-header-text-button" (click)="navigateToChaperPage()">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/banner-back-arrow.svg" />
                    <span>{{pdfUrl.title}}</span>
                </button>
            </div>
        </div>
    </div>
</div>
<div  class="pdf-container">
    <pdf-viewer
    [src]="pdfUrl.contentURL"
    [rotation]="0"
    [original-size]="false"
    [show-all]="true"
    [fit-to-page]="false"
    [zoom]="0"
    [zoom-scale]="'page-width'"
    [stick-to-page]="false"
    [render-text]="true"
    [external-link-target]="'blank'"
    [autoresize]="true"
    [show-borders]="false"
    class="viewer"
  ></pdf-viewer>
</div>
